// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__3F3BH","inputWrap":"CustomTip_inputWrap__2xr2r"};